import {useEffect, useState} from "react";
import axios from "axios";
import { config } from "../../../../Helpers/env";
import {logoutErrorMessage} from "../../../../Helpers/ErrorMessages";

export const useViewReferal = (props) =>{
    const [referral, setReferral] = useState({});
    const {visit_id} = props.match.params;
    const {actions} = props;

    useEffect(() => {
        const formData = new FormData();
        formData.append('visit_id', visit_id);
        axios.post(`${config.smsUrl}/cmedicationround/referral_note_info`, formData).then(res => {
            const data = res.data;
            const all_data = !data ? {} : data;
            setReferral(all_data)
        }).catch(e => {
            logoutErrorMessage(e, null, actions)
        })
    }, []);

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar()
    };

return {referral, closeSnackbar}
}